window.addEventListener( 'DOMContentLoaded', () => {
	const observer = new IntersectionObserver( entries => {
		entries.forEach( entry => {
			const id = entry.target.getAttribute( 'id' );
			if ( document.querySelector( 'nav.wp-block-table-of-contents li a[href$="#' + id + '"]' ) ) {
				if ( 0 < entry.intersectionRatio ) {
					document.querySelector( 'nav.wp-block-table-of-contents li a[href$="#' + id + '"]' ).classList.add( 'active' );
				} else {
					document.querySelector( 'nav.wp-block-table-of-contents li a[href$="#' + id + '"]' ).classList.remove( 'active' );
				}
			}
		} );
	} );

	// Track all headings that have an `id` applied
	document.querySelectorAll( 'h2[id], h3[id]' ).forEach( ( section ) => {
		observer.observe( section );
	} );

} );